export default __webpack_public_path__ + "static/media/Version (2) - LOTR_04.bc9965fb.jpg";